/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { getComponentFromName } from '../../lib/utils';

import { useThemeClassName } from '../../contexts/ThemeContext';
import * as SplashComponents from '../splashes/index';

import styles from '../../../styles/blocks/splash.module.scss';

const propTypes = {
    splash: PropTypes.shape({}),
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    splash: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

function SplashBlock({ splash, className, isContainer, containerClassName }) {
    const { component = null, ...splashProps } = splash || {};
    const themeClassName = useThemeClassName(styles);
    const SplashComponent = getComponentFromName(SplashComponents, component, null);
    if (SplashComponent === null) {
        return null;
    }
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <SplashComponent {...splashProps} />
            </div>
        </div>
    );
}

SplashBlock.propTypes = propTypes;
SplashBlock.defaultProps = defaultProps;

export default SplashBlock;
